var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrymasterColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 385.5 72",
    style: {
      enableBackground: "new 0 0 385.5 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000066489961305083714210000006479526196328030642_);fill:#CE0E2D;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0,
    y: 0,
    width: 385.5,
    height: 72
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000027602995546554956770000001574770129986668204_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000027602995546554956770000001574770129986668204_)",
      fill: "#CE0E2D"
    },
    d: "M55.5,0l-5.6,22.4 l-9.8,0l3-11.5c1.6-6.4-11.4-4.7-11.4-4.7l-4.4,17.1c3.2,0,3.7-0.6,4.6-3.7c0.2-0.8,0.9-2.9,0.9-2.9c0.4-1.3,1.2-2.2,2.4-2.2h3.6 l-6.6,25.4h-2.7c-1.2-0.1-2.1-0.7-1.7-2.8l1.1-4.1c0.3-1.2-0.2-2-1.3-2l-2.1,0l-5.2,19.9c-0.4,1.6,1.6,1.8,3.1,2l-1,4.1L0,56.9 l0.9-4c2.2-0.5,3.8-1.4,4.8-3.4C12.5,23.1,16.1,9.2,16.2,8.8c0.6-2.2-1.1-2.9-3.1-2.9L14.7,0L55.5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000027602995546554956770000001574770129986668204_)",
      fill: "#CE0E2D"
    },
    d: "M289.1,14.3l13.2,0 l-1.3,5.1h-11.9c-1.6,0-2,2.4-2,2.4l-7.2,27.7c-0.2,1.4,3.4,2,4.8,0.5c1.9-2.4,4.8-16.3,4.8-16.3l8.4,0c0,0-2.6,10.8-4.2,16.3 c-1.6,5.7-5.1,7-8.9,7.3c-5.8,0.5-19.6,1.5-17.7-5.8l8.2-31.3c0.2-1.2-3.1-0.6-4.6-0.9l1.2-4.4c4.1,0,9.4-2.7,10.2-6.3l1.6-5.7 l8.4,0L289.1,14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000027602995546554956770000001574770129986668204_)",
      fill: "#CE0E2D"
    },
    d: "M188.4,15.6 c1.8,1.8,1.6,4.1,0.7,7.9l-6.4,24.7c-0.7,2.7-1,3.8,2,4.8l-0.9,3.9l-15.5,0l8.6-33.5c0.5-2.1-2.3-4.1-5.3-3.2c-3,1-3.5,3.7-3.5,3.7 l-6.6,25.9c-0.5,1.9,1.8,2.7,3.2,3l-1,4.2L144,56.8l1.1-4.1c2.9,0,3.2-0.8,3.9-3.1l7.1-26.7c0.3-1.8-1.1-2.7-2.4-3 c-2.9-0.1-6.1,0.8-6.9,4.3l-6.6,25.1c-0.6,2.5,0.3,2.6,1.7,3.5l-1,4.2h-19l1.1-3.9c2.5,0,4.3-1,5.4-3.4l7-27.2 c0.2-1.3-0.6-2.8-2.3-2.8h-1l1.4-5.1h12.8c0,0.9,0.4,2.3,1.7,2.1c5.5-3.3,14.5-4.9,20.2-0.9C174,13.5,183.2,10.5,188.4,15.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000027602995546554956770000001574770129986668204_)",
      fill: "#CE0E2D"
    },
    d: "M262.1,15.8 c0.9,0.2,1.8-0.3,2-1.1h6l-3.7,13.7l-9.3-0.1c0.9-2.9,2-6-1.5-7.7c-1.7-0.8-3.6,0-5.1,0.8c-2.8,1.8-3.5,5-2.6,7.7 c2.1,5.2,13.6,1.5,16.2,8.6c1.6,6.8-2.1,13.6-8.2,17.6c-5.8,3.4-14.7,3.4-20.5,0c-1.2-0.1-2.1,0.5-2.8,1.4l-4.8,0l4.5-16h7.4 c0,0-2.3,8.1,1.7,10.3c2.5,1,5.5,0.6,7.4-1.4c2.2-2.3,3.6-6,1.7-8.4c-4.4-5-13.9-1.1-15.6-8.1c-1.3-5.9,1.7-13.2,7.9-16.8 C248.3,13.2,256.4,12.7,262.1,15.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000027602995546554956770000001574770129986668204_)",
      fill: "#CE0E2D"
    },
    d: "M129.4,14.5 c-0.1-0.2-1.5,5.1-1.3,5c-2.4,0-4,0.4-5.5,3.4L99.1,64.5c-5.1,7.2-13.1,8.5-21.4,6.8c-2.3-0.8-5-1.7-6-4.3c-0.6-2-0.1-4.1,0.6-5.9 l9.6,0.1c-0.1,2-0.2,4,2.1,4.8c2.1,0.3,3.9-0.3,5.4-1.7c2.6-2.9,1-6.6,1.4-10.5l-1.7-31.5c-0.2-2.3-0.2-2.6-2.6-2.6l1.3-5.2 c0-0.1,19.5,0,19.5,0c0.1,0-1,5.1-1.1,5.1c-1.9,0-4.5,1.1-4.3,3.1c0.2,6.5,1.1,21.1,1.1,21.1s12.4-20.8,12.5-21 c0.7-1.6-0.3-3.1-2.8-3.3c0,0,1.2-4.9,1.2-5L129.4,14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000027602995546554956770000001574770129986668204_)",
      fill: "#CE0E2D"
    },
    d: "M84,15.3l-1.7,7.4 c-4-1.2-7.3-0.9-10.7,0.6c0,0-2.6,0.7-3.4,4.3l-5.7,22.4c-0.5,1.8,2,2.8,3.7,2.8l-1,4.1l-20.7,0l1.1-4.1c2.2,0,4.5-1.1,5.3-3.8 l7.1-27.3c0.5-2.2-2.5-1.7-3.8-1.8l1.3-5.5l13.8,0c-0.3,1.3,0.3,1.9,1.1,2.3C74,14.2,80.3,13.9,84,15.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000027602995546554956770000001574770129986668204_)",
      fill: "#CE0E2D"
    },
    d: "M372.2,15.3l-1.7,7.4 c-4.1-1.2-7.3-0.9-10.7,0.6c0,0-2.5,0.7-3.4,4.3l-5.7,23.7c-0.5,1.8,3.6,1.8,3.6,1.8l-0.8,3.9l-20.7,0l1.1-4.1 c2.2,0,4.5-1.1,5.3-3.7l7.1-27.3c0.5-2.2-2.5-1.8-3.8-1.9l1.3-5.5l13.8,0c-0.3,1.3,0.3,1.9,1.1,2.3 C362.3,14.2,368.6,13.9,372.2,15.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000027602995546554956770000001574770129986668204_)",
      fill: "#CE0E2D"
    },
    d: "M313.5,36.5l20.8,0 c0,0,4.6-11.2,3.3-17.8c-2-7.6-15.7-6.1-21.8-4.6c-4.8,1.2-9.2,4-10.9,9.7l-5.7,20.8c-0.8,3.4-1.5,7.5,1.1,10.3 c4,3.6,16.3,4.1,23.3,1.1c6.2-2.9,8.7-9.2,9.4-15.3h-10.1c-0.9,3-1.5,6-3.4,8.5c-1.7,2.1-4.3,2.4-6.7,1.6c-1.4-0.7-2.4-2.2-2-4 L313.5,36.5z M320.4,20.1c1.8-0.8,3.8-0.3,5,1.2c1.1,1.4-0.9,7.1-0.9,7.1h-8.9C315.6,28.4,316.4,21.8,320.4,20.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000027602995546554956770000001574770129986668204_)",
      fill: "#CE0E2D"
    },
    d: "M227.5,19.3 c2.4-8.8-14.3-6.5-20.1-3.7c0-1.6-7.4-1.2-7.4-1.2l-3.6,14.1l5,0c6.2,0,3.6-5,7-6.9c2.4-1.5,3.3-1.5,5.7-1.3c1.3,0.2,1.7,0.4,1.4,2 c-1.4,5.6-1.2,4.6-1.3,4.9c-1.4,5.4-12.5,4.3-18.2,7.6c-5.9,3.5-9.3,12-7.1,18.5c1.8,3.5,5.4,4.3,9.1,4.3c9.6,0,9.6-3.2,11.6-3.2 c2.8,3,7.6,3.9,11.6,2.6c2.9-0.3,3.8-3.5,3.7-6c-1.2,0-5.7,0.4-5-2.4L227.5,19.3z M209.2,46.4c-1,3.6-1.8,3.8-4.6,3.9 c-1.1-0.2-3.4-0.9-3.3-2.5c0.3-4.2,2-8,6.2-9.8c1.3-0.6,2.6-0.9,4.1-0.9L209.2,46.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000027602995546554956770000001574770129986668204_)",
      fill: "#CE0E2D"
    },
    d: "M384.2,18.7 c0,2-1.4,3.3-3.1,3.3c-1.7,0-3.1-1.3-3.1-3.3c0-2,1.4-3.3,3.1-3.3C382.8,15.4,384.2,16.7,384.2,18.7 M380.4,19h0.5l1.1,2h1.2 l-1.2-2c0.6-0.1,1.1-0.4,1.1-1.2c0-1.1-0.7-1.4-1.9-1.4h-1.7V21h1V19z M380.4,18.2v-1.1h0.7c0.4,0,0.9,0,0.9,0.5 c0,0.5-0.3,0.6-0.7,0.6H380.4z M385.5,18.7c0-2.7-2-4.3-4.3-4.3c-2.3,0-4.3,1.6-4.3,4.3c0,2.7,2,4.3,4.3,4.3 C383.4,23,385.5,21.4,385.5,18.7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrymasterColor);
export default __webpack_public_path__ + "static/media/Frymaster_Color.139683c5986539e516f5d329125ee746.svg";
export { ForwardRef as ReactComponent };